import {formatSlotDateTime} from './formatSlotDateTime'
import {formatBookingSummary} from './mockMatches'

// V2 bookingDate is an opaque slot id, never a calendar date.
export function bookingSummary(draft = {}, session = {}, lang = 'fa', live = true) {
  session = session || {}
  const start = session.selectedSlotStartsAt || draft.bookingDate
  if (/^\d{4}-\d{2}-\d{2}T/.test(String(start || '')) && Number.isFinite(Date.parse(start))) {
    return formatSlotDateTime(start, lang).combinedLabel
  }
  if (session.selectedSlotDateLabel && session.selectedSlotTimeLabel) {
    return `${session.selectedSlotDateLabel} · ${session.selectedSlotTimeLabel}`
  }
  if (!live && !session.recommendationId) {
    return formatBookingSummary(draft.bookingDate, draft.bookingTime, lang)
  }
  return lang === 'fa' ? 'زمان انتخاب‌شده در دسترس نیست؛ زمان تازه‌ای انتخاب کن.' : 'The selected time is unavailable; choose another time.'
}
